export const booksData = [
    {
        id: 1,
        img: "https://imgv2-1-f.scribdassets.com/img/document/399761348/original/75a5c87340/1616077294?v=1",
        title: "Andrew Ng's Notes",
        author: "Andrew Ng",
        source: "https://www.kaggle.com/getting-started/102365",
        topics: "Machine Learning, Deep Learning, Programming",
        category: "Machine Learning",
        info: "These are the collections of notes from Andrew Ng gathered throughout his online courses in machine and deep learning."
    },
    {
        id: 2,
        img: "notes-images/ANN-for-beginners.png",
        title: "Artificial Neural Networks for Beginners",
        author: "Carlos Gershenson",
        source: "https://www.uv.mx/mia/files/2012/10/Artificial-Neural-Networks-for-Beginners.pdf",
        topics: "Machine Learning, Deep Learning, Programming",
        category: "Machine Learning",
        info: "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque antesollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempusviverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Doneclacinia congue felis in faucibus."
    },
    {
        id: 3,
        img: "https://simg.nicepng.com/png/small/80-804192_smartlogic-explores-javascript-react-and-flux-tech.png",
        title: "The React Cheatsheet for 2021‬ (+ Real-World Examples)",
        author: "Reed Barger",
        source: "https://www.freecodecamp.org/news/react-cheatsheet-with-real-world-examples/",
        topics: "Machine Learning, Deep Learning, Programming",
        category: "Machine Learning",
        info: "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque antesollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempusviverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Doneclacinia congue felis in faucibus."
    },
    

   
];